var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_788_55599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1785 5.38317L7.02452 0.333405C6.57282 -0.118294 5.83157 -0.106712 5.39146 0.344987L0.330109 5.51057C-0.12159 5.96227 -0.110008 6.70352 0.341691 7.14364C0.56175 7.3637 0.862883 7.47952 1.15243 7.47952C1.44198 7.47952 1.7547 7.3637 1.97476 7.13206L5.10191 3.947V20.0113C5.10191 20.6483 5.6231 21.1695 6.26011 21.1695C6.89712 21.1695 7.41831 20.6483 7.41831 20.0113V3.95858L10.557 7.0394C11.0087 7.4911 11.75 7.47952 12.1901 7.02782C12.6418 6.57612 12.6302 5.83487 12.1785 5.39475V5.38317Z",
    fill: "#4A5771"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_788_55599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.5318,
    height: 21.172,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTop);
export default __webpack_public_path__ + "static/media/arrow-top.538b7ddbd39bb767b53943dc90a213fe.svg";
export { ForwardRef as ReactComponent };